// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1WYrz","content":"ManualTimeModal_content__2eVNY"};